'use strict';

var App = require('app');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var Utils = require('models/utils');

var GatewayConnectionStatistic = Backbone.Model.extend({
    url: '/api/v1/devices/connectionstats',

    defaults: {
        modelType: 'gateway_statistic',
    },

    initialize: function () {
        Utils.SelectableModel.applyTo(this);
    },
});

var GatewayConnectionStatisticCollection = Backbone.Collection.extend({
    url: '/api/v1/devices/connectionstats',
    model: GatewayConnectionStatistic,

    initialize: function (options) {
        Utils.SelectableCollection.applyTo(this, options);

        var url = this.url + '?';
        _.each(options, function (value, key) {
            url += key + '=' + value + '&';
        });
        this.url = url.substring(0, url.length - 1);
    },

    getSelectedCollection: function (idList) {
        var list = Misc.selectWhere(_.pairs(this.selected), undefined, function (item) {
            return item[1];
        });
        return new GatewayConnectionStatisticCollection(list);
    },

    parse: function (response, xhr) {
        _.each(response.gateway_list, function (gateway, idx) {
            response.gateway_list[idx] = gateway;
        });
        return response.gateway_list;
    },

    setPage: function (page, itemsPerPage, sortCol, sortDesc, onComplete) {
        var self = this;
        var filter = {
            columns: ['data_day', 'data_week', 'data_month', 'online_day', 'online_week', 'online_month'],

            sortCol: sortCol,
            sortDesc: sortDesc,

            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
        };

        var statistics = new GatewayConnectionStatisticCollection(filter);

        statistics.fetch({
            type: 'GET',

            success: function (collection, data) {
                collection.buildData(data);
                self.itemsPerPage = itemsPerPage;
                self.itemCount = data.count;
                self.average_values = data.average_values;

                onComplete(collection, data.count);
            },

            error: function (data) {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Seite konnte nicht geladen werden.'));
            },
        });
    },

    buildData: function (data) {
        var self = this;
        _.each(this.models, function (model, idx) {
            var tempData = {};
            _.each(model.attributes.data, function (value, i) {
                tempData[data.columns[i]] = value;
            });
            self.models[idx].attributes.data = tempData;
        });
    },
});

var API = {
    gatewayConnectionStatistics: function (filter) {
        var statistics = new GatewayConnectionStatisticCollection(filter);
        var defer = $.Deferred();

        statistics.fetch({
            type: 'GET',

            success: function (collection, data) {
                collection.buildData(data);
                defer.resolve({
                    collection: collection,
                    count: data.count,
                    average_values: data.average_values,
                    columns: data.columns,
                });
            },

            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('gateway:connection:statistics', function (filter) {
    return API.gatewayConnectionStatistics(filter);
});

module.exports = {
    Collection: GatewayConnectionStatisticCollection,
};
